import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class AddressTokenTransfers extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default AddressTokenTransfers
